import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";
import { dialogTitleCenterSx } from "../common/dialogTitleCenterSx";

interface ContactCompanyAdminModalProps {
  open: boolean;
  onClose: () => void;
}

const ContactCompanyAdminModal: React.FC<ContactCompanyAdminModalProps> = ({
  open,
  onClose
}) => {
  const { t } = useKivunovaTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={dialogTitleCenterSx}>
        <Typography variant="h6" fontWeight="bold">
          {t("contact-admin-modal-title", "Subscription access")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t(
            "contact-admin-modal-message",
            "Only company administrators can manage subscriptions. Please contact your company admin to subscribe or view subscription details."
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: BRAND_COLOR,
            "&:hover": {
              backgroundColor: BRAND_HOVER
            }
          }}
        >
          {t("contact-admin-modal-ok", "OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactCompanyAdminModal;
